import { restDownloadFile } from '../services/common/utils';

export const downloadFile = (params: any) => {
    let path;
    if (params.type === 'tasks') {
        path = `/${params.type}/${params.taskId}/attachments/${params.attachmentId}`;
        restDownloadFile(path);
    }
};
